import React, { useEffect, useState } from "react";
import styles from "../PaymentType.module.css";
import { styled } from "@mui/material/styles";
import {
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Popover,
  Switch,
  SwitchProps,
  Tooltip,
} from "@mui/material";
import PaymentEnablePopup from "./PaymentEnablePopup";
import PaymentDisablePopup from "./PaymentDisablePopup";
import {
  cancelEnach,
  copyEnachLinkHit,
  deactivateEnach,
  resendEnach,
  studentAutoDebit,
} from "../../../service/nurtureSlice";
import { useDispatch } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import dots from "../../../../../../assets/images/unionDots.svg";
import moment from "moment";
import { timeZoneConverter } from "../../../../../../components/Formatter/Formatter";
import CancelPaymentLinkPopup from "../../PaymentLinkPopup/CancelPaymentLinkPopup";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#23A67B",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

function LeadPaymentAutoDebit(props: any) {
  const { leadData, paymentType } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { autoDebitSuccess, autoDebitLoading } = useSelector(
    (state: any) => state.nurture
  );
  const instituteData = useSelector(
    (state: any) => state.institute.instituteDetails
  );
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasLeadAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_CARD",
    "ALL_ACCESS",
    userById?.rolePermission
  );
  const hasNurturePay =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("NURTURE_PAY_EASEBUZZ");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [cancelPopup, setCancelPopup] = useState<boolean>(false);
  const [total, setTotal] = useState<string>("");
  const [endDateOfEnach, setEndDateOfEnach] = useState(`${moment().unix()}`);
  const [cancelPopupBeforeActivating, setCancelPopupBeforeActivating] =
    useState<boolean>(false);

  const open = Boolean(anchorEl);

  const [autoDebitEnablePopup, setAutoDebitEnablePopup] =
    React.useState<boolean>(false);
  const [autoDebitDisablePopup, setAutoDebitDisablePopup] =
    React.useState<boolean>(false);
  const [autoDebitStatus, setAutoDebitStatus] = React.useState<boolean>(false);

  const openAutoEnablePopup = () => {
    setAutoDebitEnablePopup(true);
  };
  const closeAutoEnablePopup = () => {
    setAutoDebitEnablePopup(false);
  };

  const openAutoDebitDisablePopup = () => {
    setAutoDebitDisablePopup(true);
  };
  const closeAutoDebitDisablePopup = () => {
    setAutoDebitDisablePopup(false);
  };

  const handleChangeCheck = React.useCallback(
    async (event: any) => {
      // setAutoDebitStatus(!autoDebitStatus);
      const value = event.target.checked;
      if (!value) {
        openAutoDebitDisablePopup();
      } else {
        openAutoEnablePopup();
      }
    },

    []
  );

  useEffect(() => {
    if (leadData?.paymentDetails?.paymentType === "MEMBERSHIP") {
      const value =
        leadData?.paymentDetails?.EMIDetails?.emiMode === "MONTHLY"
          ? leadData?.paymentDetails?.finalAmount * 12
          : leadData?.paymentDetails?.EMIDetails?.emiMode === "TWO_MONTHS"
          ? leadData?.paymentDetails?.finalAmount * 6
          : leadData?.paymentDetails?.EMIDetails?.emiMode === "QUARTERLY"
          ? leadData?.paymentDetails?.finalAmount * 4
          : leadData?.paymentDetails?.EMIDetails?.emiMode === "HALF_YEARLY"
          ? leadData?.paymentDetails?.finalAmount * 2
          : leadData?.paymentDetails?.finalAmount;
      setTotal(value);
      const oneYearLaterUnix = moment().add(1, "year").unix();
      setEndDateOfEnach(timeZoneConverter(oneYearLaterUnix));
    } else if (leadData?.paymentDetails?.paymentType === "REGULAR") {
      setTotal(leadData?.balanceAmount);
      setEndDateOfEnach(leadData?.bacthEndDate);
    }
  }, [leadData]);

  const studentAutoDebitEnableSubmit = () => {
    const data = {
      instituteId: authUser?.institute?.[0]?.instituteId,
      enquiryId: leadData?.id,
      autoDebitType: "UPI",
      endDate: endDateOfEnach,
      max_debit_amount: total,
    };
    dispatch<any>(studentAutoDebit({ data, actionType: "enabled" }));
  };

  const studentAutoDebitDisableSubmit = () => {
    const data = {
      instituteId: authUser?.institute?.[0]?.instituteId,
      enquiryId: leadData?.id,
      autoDebitType: "UPI",
      endDate: endDateOfEnach,
      max_debit_amount: total,
    };

    dispatch<any>(studentAutoDebit({ data, actionType: "disabled" }));
  };

  React.useEffect(() => {
    if (autoDebitSuccess !== true && autoDebitSuccess !== false) {
      setAutoDebitEnablePopup(false);
      setAutoDebitDisablePopup(false);
    }
  }, [autoDebitSuccess]);

  React.useEffect(() => {
    if (leadData?.autoDebit) {
      if (
        leadData?.autoDebitType === "UPI" &&
        (leadData?.autoDebit === "ENABLED" ||
          leadData?.autoDebit === "UNDER_PROCESSING")
      ) {
        setAutoDebitStatus(true);
      } else {
        setAutoDebitStatus(false);
      }
    }
  }, [leadData]);

  const handleCancelClose = () => {
    setAnchorEl(null);
  };

  const openCancelPopup = () => {
    setCancelPopup(true);
  };
  const closeCancelPopup = () => {
    setCancelPopup(false);
  };

  const handleCancelOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const cancelConfirmBeforeActivating = () => {
    setCancelPopupBeforeActivating(false);
    const body = {
      enquiryId: leadData?.id,
    };
    dispatch<any>(cancelEnach(body));
  };

  const resendBeforeActivating = () => {
    const body = {
      enquiryId: leadData?.id,
    };
    dispatch<any>(resendEnach(body));
  };

  const copyEnachLinkSumit = () => {
    const body = {
      enquiryId: leadData?.id,
    };
    dispatch<any>(copyEnachLinkHit(body));
  };

  const openCancelPopupBeforeActivating = () => {
    setCancelPopupBeforeActivating(true);
  };

  const closeCancelPopupBeforeActivating = () => {
    setCancelPopupBeforeActivating(false);
  };

  const cancelConfirm = () => {
    setCancelPopup(false);
    const body = {
      instituteId: authUser?.institute[0]?.instituteId,
      enquiryId: leadData?.id,
    };
    dispatch<any>(deactivateEnach(body));
  };

  return (
    <>
      <div
        className={styles.leadAutoDebitBox}
        style={{
          padding: paymentType === "RECURRING" ? "20PX 0PX" : "20PX 30PX",
        }}
      >
        <div className={styles.leadAutoDebitBoxChild}>
          <div className={styles.leadAutoDebitBoxLeft}>
            <div className={styles.leadAutoDebitTitle}>UPI Auto Debit</div>
            <div className={styles.leadAutoDebitDesc}>
              You need to first activate the auto debit facility from the
              payment issuer’s app.
            </div>
          </div>
          <div
            className={styles.leadAutoDebitBoxRight}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <FormControl
              fullWidth
              variant="standard"
              className="formControl"
              sx={{ width: "auto" }}
            >
              <Tooltip
                title={
                  hasLeadAccess === false
                    ? "Oops! No permission."
                    : !hasNurturePay
                    ? "Please complete nurture pay integration"
                    : leadData?.studentContact === ""
                    ? "Please add Phone number to get this feature"
                    : leadData?.studentEmail === ""
                    ? "Please add email to get this feature"
                    : leadData?.autoDebitType === "UPI" &&
                      leadData?.autoDebit === "UNDER_PROCESSING"
                    ? "Pending"
                    : ""
                }
                placement="bottom"
                arrow
                PopperProps={{ style: { zIndex: 999999 } }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#101828",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "500",
                      padding: "8px 12px",
                      zIndex: "999999",
                      "& .MuiTooltip-arrow": {
                        color: "#101828",
                        zIndex: "999999",
                      },
                    },
                  },
                }}
              >
                <FormControlLabel
                  style={{
                    justifyContent: "flex-end",
                    marginLeft: 0,
                    color: "#3F3E43",
                    marginTop: "0px",
                    gap: 20,
                  }}
                  control={
                    <IOSSwitch
                      sx={{ margin: "1px" }}
                      checked={autoDebitStatus}
                      id="studentAutoDebit"
                      onChange={(e) => {
                        handleChangeCheck(e);
                      }}
                      disabled={
                        hasLeadAccess === false
                          ? true
                          : false ||
                            !hasNurturePay ||
                            leadData?.studentEmail === "" ||
                            ((leadData?.autoDebit === "UNDER_PROCESSING" ||
                              leadData?.autoDebit === "ENABLED") &&
                              (leadData?.autoDebitType === "ENACH" ||
                                leadData?.autoDebitType === undefined)) ||
                            (leadData?.autoDebit === "UNDER_PROCESSING" &&
                              leadData?.autoDebitType === "UPI") ||
                            leadData?.studentContact === ""
                      }
                    />
                  }
                  label=""
                  labelPlacement="start"
                />
              </Tooltip>
            </FormControl>
            {leadData?.autoDebitType === "UPI" &&
              leadData?.autoDebit === "ENABLED" && (
                <div>
                  <Tooltip
                    arrow
                    title={""}
                    PopperProps={{ style: { zIndex: 999999 } }}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#101828",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "8px 12px",
                          zIndex: "999999",
                          "& .MuiTooltip-arrow": {
                            color: "#101828",
                            zIndex: "999999",
                          },
                        },
                      },
                    }}
                  >
                    <span>
                      <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleCancelOpen}
                        sx={{
                          width: "20px",
                          height: "20px",
                          border: "none",
                          borderRadius: "4PX",
                          background: "trasnarent",
                          "&:hover": {
                            background: "transparent",
                          },
                        }}
                      >
                        <img src={dots} alt="" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Popover
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCancelClose}
                    sx={{ zIndex: 999999 }}
                    PaperProps={{
                      style: {
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                        borderRadius: "4PX",
                        border: "1px solid #E4E4E7",
                        zIndex: 999999,
                      },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: -5,
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#EC3939",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        openCancelPopup();
                      }}
                    >
                      Cancel Easy EMI's
                    </MenuItem>
                  </Popover>
                </div>
              )}
            {leadData?.autoDebitType === "UPI" &&
              leadData?.autoDebit === "UNDER_PROCESSING" && (
                <div>
                  <Tooltip
                    arrow
                    title={""}
                    PopperProps={{ style: { zIndex: 999999 } }}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#101828",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "8px 12px",
                          zIndex: "999999",
                          "& .MuiTooltip-arrow": {
                            color: "#101828",
                            zIndex: "999999",
                          },
                        },
                      },
                    }}
                  >
                    <span>
                      <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleCancelOpen}
                        sx={{
                          width: "20px",
                          height: "20px",
                          border: "none",
                          borderRadius: "4PX",
                          background: "trasnarent",
                          "&:hover": {
                            background: "transparent",
                          },
                        }}
                      >
                        <img src={dots} alt="" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Popover
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCancelClose}
                    sx={{ zIndex: 999999 }}
                    PaperProps={{
                      style: {
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                        borderRadius: "4PX",
                        border: "1px solid #E4E4E7",
                        zIndex: 999999,
                      },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: -5,
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "rgba(29, 86, 207, 0.8)",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        copyEnachLinkSumit();
                      }}
                    >
                      Copy Link
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#EC3939",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        openCancelPopupBeforeActivating();
                      }}
                    >
                      Cancel Easy EMI's Link
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "rgba(29, 86, 207, 0.8)",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        resendBeforeActivating();
                      }}
                    >
                      Resend Easy EMI's Link
                    </MenuItem>
                  </Popover>
                </div>
              )}
          </div>
        </div>
      </div>
      <PaymentEnablePopup
        open={autoDebitEnablePopup}
        onClose={closeAutoEnablePopup}
        yesButtonClick={studentAutoDebitEnableSubmit}
        loader={autoDebitLoading}
      />
      <PaymentDisablePopup
        open={autoDebitDisablePopup}
        onClose={closeAutoDebitDisablePopup}
        yesButtonClick={studentAutoDebitDisableSubmit}
        loader={autoDebitLoading}
      />
      <CancelPaymentLinkPopup
        open={cancelPopupBeforeActivating}
        onClose={closeCancelPopupBeforeActivating}
        noButtonClick={closeCancelPopupBeforeActivating}
        yesButtonClick={cancelConfirmBeforeActivating}
      />
      <CancelPaymentLinkPopup
        open={cancelPopup}
        onClose={closeCancelPopup}
        noButtonClick={closeCancelPopup}
        yesButtonClick={cancelConfirm}
      />
    </>
  );
}

export default LeadPaymentAutoDebit;
